// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"7a84388c","787":"75b412fd","871":"aae22dc4"}[chunkId] + ".chunk.js";
};